import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const IDLE_MS = 2 * 60 * 60 * 1000;
const WARNING_MS = 60 * 1000;
const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'touchstart', 'scroll', 'wheel'];

const IdleLogoutMonitor = () => {
  const { token, logout } = useAuth();
  const navigate = useNavigate();
  const lastActivityRef = useRef(Date.now());
  const warningStartedAtRef = useRef(null);
  const [warningOpen, setWarningOpen] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(Math.floor(WARNING_MS / 1000));

  useEffect(() => {
    if (!token) return undefined;
    const onActivity = () => {
      if (!warningStartedAtRef.current) {
        lastActivityRef.current = Date.now();
      }
    };
    ACTIVITY_EVENTS.forEach(ev => window.addEventListener(ev, onActivity, { passive: true }));
    return () => ACTIVITY_EVENTS.forEach(ev => window.removeEventListener(ev, onActivity));
  }, [token]);

  useEffect(() => {
    if (!token) {
      warningStartedAtRef.current = null;
      setWarningOpen(false);
      return undefined;
    }
    const tick = setInterval(() => {
      if (warningStartedAtRef.current) {
        const elapsed = Date.now() - warningStartedAtRef.current;
        const remaining = Math.max(0, Math.ceil((WARNING_MS - elapsed) / 1000));
        setSecondsLeft(remaining);
        if (remaining <= 0) {
          warningStartedAtRef.current = null;
          setWarningOpen(false);
          logout();
          navigate('/login');
        }
      } else {
        const idleMs = Date.now() - lastActivityRef.current;
        if (idleMs >= IDLE_MS - WARNING_MS) {
          warningStartedAtRef.current = Date.now();
          setSecondsLeft(Math.floor(WARNING_MS / 1000));
          setWarningOpen(true);
        }
      }
    }, 1000);
    return () => clearInterval(tick);
  }, [token, logout, navigate]);

  const handleStay = () => {
    warningStartedAtRef.current = null;
    lastActivityRef.current = Date.now();
    setWarningOpen(false);
  };

  const handleLogoutNow = () => {
    warningStartedAtRef.current = null;
    setWarningOpen(false);
    logout();
    navigate('/login');
  };

  if (!warningOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleStay}>
      <div className="app-modal" onClick={e => e.stopPropagation()}>
        <div className="app-modal-icon"><Clock size={44} color="#f59e0b" /></div>
        <p className="app-modal-message">
          Vas a cerrar sesión por inactividad en <strong>{secondsLeft}s</strong>.
        </p>
        <div className="app-modal-actions">
          <button className="btn btn-outline" onClick={handleLogoutNow}>Salir ahora</button>
          <button className="btn btn-primary" onClick={handleStay}>Seguir conectado</button>
        </div>
      </div>
    </div>
  );
};

export default IdleLogoutMonitor;
